export var DELIVERY_TYPE_STATUS;
(function (DELIVERY_TYPE_STATUS) {
    DELIVERY_TYPE_STATUS["THRESHOLD"] = "THRESHOLD";
    DELIVERY_TYPE_STATUS["LOCKBOX"] = "LOCKBOX";
    DELIVERY_TYPE_STATUS["OUTSIDE"] = "OUTSIDE";
})(DELIVERY_TYPE_STATUS || (DELIVERY_TYPE_STATUS = {}));
